export const RESET = 'RESET'
export const MAKE = 'MAKE'
export const PRESERVE = 'PRESERVE'
export const LEARN = 'LEARN'
export const BUY = 'BUY'
export const HIGHLIGHT = 'HIGHLIGHT'

export const STAGES = [MAKE, BUY, LEARN, PRESERVE]
export const GENERICS = [RESET, HIGHLIGHT]

export const READINESS_ASSESSMENT = 'readinessAssessment'
